import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  backButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
  },
  backButton: {
    padding: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  backIcon: {
    color: '#E94745',
    fontSize: 'clamp(12px, 1.60vw, 34px)',
    fontWeight: 700,
  },
  pageTitle: {
    fontSize: 'clamp(10px, 1.30vw, 25px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  enrollmentsContainer: {
    marginTop: theme.spacing(3),
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-root': {
      fontSize: 'clamp(10px, 1.2vw, 16px)',
      fontWeight: 700,
      color: theme.palette.primary.main,
      fontFamily: 'Montserrat',
    },
  },
}));

export default useStyles;
